import React, { useState } from 'react';

// ==========================================
// SVG Icons Library - Minimalist Style
// ==========================================

const Icons = {
  // Category Icons
  Code: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M16 18L22 12L16 6M8 6L2 12L8 18"
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  Chat: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M21 11.5C21 16.75 16.75 21 11.5 21C9.5 21 7.5 20.5 6 19.5L2 21L3.5 17C2.5 15.5 2 13.5 2 11.5C2 6.25 6.25 2 11.5 2C16.75 2 21 6.25 21 11.5Z"
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7 10H16M7 14H12" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),

  Text: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M3 7H21M3 12H21M3 17H15"
        stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),

  Image: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <rect x="3" y="3" width="18" height="18" rx="2"
        stroke={color} strokeWidth="2"/>
      <circle cx="8.5" cy="8.5" r="1.5" fill={color}/>
      <path d="M21 15L16 10L5 21"
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  ImageAnalysis: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <rect x="3" y="3" width="18" height="18" rx="2" stroke={color} strokeWidth="2"/>
      <path d="M3 14L8 9L12 13L21 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="8.5" cy="8.5" r="1.5" fill={color}/>
    </svg>
  ),

  TextToVideo: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <rect x="4" y="7" width="16" height="11" rx="2" stroke={color} strokeWidth="2"/>
      <polygon points="10,10 15,12.5 10,15" fill={color}/>
      <circle cx="7" cy="4" r="1.5" fill={color}/>
      <circle cx="11" cy="2" r="1" fill={color}/>
      <circle cx="4" cy="6" r="1" fill={color}/>
    </svg>
  ),

  ImageToVideo: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <rect x="2" y="5" width="20" height="14" rx="2" stroke={color} strokeWidth="2"/>
      <path d="M10 9L15 12L10 15V9Z" fill={color}/>
      <path d="M2 9H6M18 9H22M2 15H6M18 15H22" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),

  Video: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <rect x="2" y="6" width="20" height="12" rx="2" stroke={color} strokeWidth="2"/>
      <path d="M10 9.5L15 12L10 14.5V9.5Z" fill={color}/>
    </svg>
  ),

  Translation: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2"/>
      <path d="M2 12H22M12 2C14.5 4.5 16 8 16 12C16 16 14.5 19.5 12 22M12 2C9.5 4.5 8 8 8 12C8 16 9.5 19.5 12 22"
        stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),

  // Data Analysis Icon
  Data: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M3 3V16C3 17.1 3.9 18 5 18H21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M7 14L11 10L15 14L21 8" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="21" cy="8" r="2" fill={color}/>
    </svg>
  ),

  // Data Analysis with Table
  DataAnalysis: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <rect x="3" y="3" width="18" height="18" rx="2" stroke={color} strokeWidth="2"/>
      <path d="M3 9H21M3 15H21M9 3V21M15 3V21" stroke={color} strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
      <circle cx="6" cy="6" r="1" fill={color}/>
      <circle cx="12" cy="12" r="1" fill={color}/>
      <circle cx="18" cy="18" r="1" fill={color}/>
      <path d="M6 6L12 12L18 18" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),

  // Performance Metrics Icons
  Speed: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12"
        stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M12 6V12L16 14"
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  Dollar: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 1V23M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  Quality: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  Vote: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
        fill={color} stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  ),

  VoteAlt: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M7 22V11M2 13L7 7L12 13M17 22V11M12 13L17 7L22 13"
        stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  User: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="2"/>
      <path d="M6 21C6 17.6863 8.68629 15 12 15C15.3137 15 18 17.6863 18 21"
        stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),

  Sparkles: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 3L13.5 7.5L18 9L13.5 10.5L12 15L10.5 10.5L6 9L10.5 7.5L12 3Z"
        fill={color} stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M19 12L19.5 13.5L21 14L19.5 14.5L19 16L18.5 14.5L17 14L18.5 13.5L19 12Z"
        fill={color}/>
      <path d="M6 18L6.5 19.5L8 20L6.5 20.5L6 22L5.5 20.5L4 20L5.5 19.5L6 18Z"
        fill={color}/>
    </svg>
  ),

  // Stats/Analytics Icon
  Stats: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M18 20V10M12 20V4M6 20V14" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  // Eye Icon for Toggle
  Eye: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="2"/>
    </svg>
  ),

  // Eye Off Icon
  EyeOff: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M17.94 17.94A10.07 10.07 0 0112 20C5 20 1 12 1 12A18.45 18.45 0 015.06 7.06M9.9 4.24A9.12 9.12 0 0112 4C19 4 23 12 23 12A18.5 18.5 0 0120.18 15.96" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1 1L23 23" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  // More/Menu Icon
  More: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <circle cx="12" cy="12" r="1.5" fill={color}/>
      <circle cx="12" cy="5" r="1.5" fill={color}/>
      <circle cx="12" cy="19" r="1.5" fill={color}/>
    </svg>
  ),

  // Check/Winner Icon
  Check: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M20 6L9 17L4 12" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  // Trophy/Winner Icon
  Trophy: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M6 9H4C3 9 2 8 2 7V5C2 4 3 3 4 3H6M18 9H20C21 9 22 8 22 7V5C22 4 21 3 20 3H18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 3H18V9C18 13 15 16 12 16C9 16 6 13 6 9V3Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 16V19M8 21H16M8 21V19H16V21H8Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),

  // NEW: Compare Icon - Two items side by side
  Compare: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <rect x="2" y="4" width="8" height="16" rx="2" stroke={color} strokeWidth="2"/>
      <rect x="14" y="4" width="8" height="16" rx="2" stroke={color} strokeWidth="2"/>
      <path d="M10 12H14" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <path d="M6 8V16M18 8V16" stroke={color} strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    </svg>
  ),

  // NEW: Users/Community Icon
  Users: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <circle cx="9" cy="7" r="3" stroke={color} strokeWidth="2"/>
      <path d="M3 21C3 17 6 14 9 14C12 14 15 17 15 21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
      <circle cx="17" cy="8" r="2.5" stroke={color} strokeWidth="2"/>
      <path d="M21 21C21 18 19 16 17 16C15.5 16 14.5 17 14 18" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),

  // NEW: Fire/Trending Icon
  Fire: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M12 2C12 2 8 6 8 10C8 12.5 9.5 14.5 12 15C10 13 11 10 12 9C13 10 14 13 12 15C14.5 14.5 16 12.5 16 10C16 6 12 2 12 2Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 22C16 22 19 19 19 15C19 11 15 8 12 8C9 8 5 11 5 15C5 19 8 22 12 22Z" stroke={color} strokeWidth="2"/>
    </svg>
  ),

  // Category/Grid Icon - for Dashboard stats
  Category: ({ size = 24, color = 'currentColor', className = '' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
      <rect x="3" y="3" width="7" height="7" rx="1.5" stroke={color} strokeWidth="2"/>
      <rect x="14" y="3" width="7" height="7" rx="1.5" stroke={color} strokeWidth="2"/>
      <rect x="3" y="14" width="7" height="7" rx="1.5" stroke={color} strokeWidth="2"/>
      <rect x="14" y="14" width="7" height="7" rx="1.5" stroke={color} strokeWidth="2"/>
    </svg>
  ),
};

// ==========================================
// Color System
// ==========================================

const IconColors = {
  categories: {
    code: '#8B5CF6',       // סגול
    chat: '#3B82F6',       // כחול
    text: '#3B82F6',       // כחול (legacy)
    image: '#10B981',      // ירוק
    imageAnalysis: '#06B6D4', // ציאן
    video: '#EC4899',      // ורוד
    imageToVideo: '#F97316', // כתום
    textToVideo: '#A855F7',  // סגול בהיר
    translation: '#F59E0B',  // צהוב (legacy)
    data: '#6366F1',       // אינדיגו (legacy)
    dataAnalysis: '#6B7280', // אפור (legacy)
  },

  performance: {
    winner: '#10B981',
    loser: '#EF4444',
    tie: '#6B7280',
  },
};

// ==========================================
// Helper: Get Category Icon
// ==========================================

const getCategoryIcon = (category, size = 24, color = null) => {
  const iconMap = {
    'CODE_GENERATION': { Icon: Icons.Code, color: IconColors.categories.code },
    'CHAT': { Icon: Icons.Chat, color: IconColors.categories.chat },
    'IMAGE_GENERATION': { Icon: Icons.Image, color: IconColors.categories.image },
    'IMAGE_ANALYSIS': { Icon: Icons.ImageAnalysis, color: IconColors.categories.imageAnalysis },
    'IMAGE_TO_VIDEO': { Icon: Icons.ImageToVideo, color: IconColors.categories.imageToVideo },
    'VIDEO_GENERATION': { Icon: Icons.Video, color: IconColors.categories.video },
    'TEXT_TO_VIDEO': { Icon: Icons.TextToVideo, color: IconColors.categories.textToVideo },
    // Legacy categories (for backward compatibility with old data)
    'TEXT_SUMMARIZATION': { Icon: Icons.Text, color: IconColors.categories.text },
    'MULTILINGUAL_TRANSLATION': { Icon: Icons.Translation, color: IconColors.categories.translation },
    'RAG_DATA_ANALYSIS': { Icon: Icons.Data, color: IconColors.categories.data },
    'DATA_ANALYSIS': { Icon: Icons.DataAnalysis, color: IconColors.categories.dataAnalysis },
  };

  const config = iconMap[category] || { Icon: Icons.Chat, color: IconColors.categories.chat };
  const IconComponent = config.Icon;

  return <IconComponent size={size} color={color || config.color} />;
};

// ==========================================
// Helper: Comparison Colors
// ==========================================

const getComparisonColors = (leftValue, rightValue, metric) => {
  const isLowerBetter = metric === 'latency' || metric === 'cost';

  if (leftValue === rightValue) {
    return { leftColor: IconColors.performance.tie, rightColor: IconColors.performance.tie };
  }

  const leftWins = isLowerBetter ? leftValue < rightValue : leftValue > rightValue;

  return {
    leftColor: leftWins ? IconColors.performance.winner : IconColors.performance.loser,
    rightColor: leftWins ? IconColors.performance.loser : IconColors.performance.winner,
  };
};

// ==========================================
// Helper Functions
// ==========================================

const getInitials = (name) => {
  if (!name) return 'AI';
  return name
    .split(/[\s-_]/)
    .map(word => word[0])
    .filter(Boolean)
    .join('')
    .toUpperCase()
    .slice(0, 2) || 'AI';
};

const getColorFromName = (name) => {
  const nameL = (name || '').toLowerCase();

  // Brand-specific colors
  if (nameL.includes('gpt') || nameL.includes('dall-e') || nameL.includes('openai')) return 'bg-black';
  if (nameL.includes('claude') || nameL.includes('anthropic')) return 'bg-gradient-to-br from-orange-400 to-red-500';
  if (nameL.includes('gemini') || nameL.includes('google')) return 'bg-gradient-to-br from-blue-500 to-purple-500';
  if (nameL.includes('stable') || nameL.includes('sdxl') || nameL.includes('stability')) return 'bg-gradient-to-br from-purple-600 to-pink-500';
  if (nameL.includes('llama') || nameL.includes('meta')) return 'bg-gradient-to-br from-blue-600 to-cyan-500';
  if (nameL.includes('mistral') || nameL.includes('mixtral')) return 'bg-gradient-to-br from-orange-500 to-amber-600';
  if (nameL.includes('deepseek')) return 'bg-gradient-to-br from-indigo-500 to-blue-600';
  if (nameL.includes('qwen')) return 'bg-gradient-to-br from-orange-500 to-red-500';

  // Generic colors by hash
  const colors = [
    'bg-blue-500',
    'bg-purple-500',
    'bg-green-500',
    'bg-pink-500',
    'bg-indigo-500',
    'bg-red-500',
    'bg-yellow-500',
    'bg-teal-500',
  ];
  const index = (name || 'AI').charCodeAt(0) % colors.length;
  return colors[index];
};

// ==========================================
// Get Logo URL - PNG format
// ==========================================

const getLogoUrl = (model, modelName) => {
  const searchParts = [
    model?.id,
    model?.name,
    model?.provider,
    modelName
  ].filter(Boolean);

  const searchString = searchParts.join(' ').toLowerCase();

  if (model?.logo_url) {
    return model.logo_url;
  }

  // Brand detection - PNG logos
  if (searchString.includes('claude') || searchString.includes('anthropic')) {
    return '/logos/anthropic.png';
  }
  if (searchString.includes('gpt') || searchString.includes('dall-e') || searchString.includes('openai')) {
    return '/logos/openai.png';
  }

  // OpenAI - add sora
  if (searchString.includes('gpt') || searchString.includes('dall-e') || searchString.includes('openai') || searchString.includes('sora')) {
    return '/logos/openai.png';
  }

  // ByteDance - Seedance, Seedream
  if (searchString.includes('bytedance') || searchString.includes('seedance') || searchString.includes('seedream')) {
    return '/logos/bytedance.png';
  }

  // PixVerse
  if (searchString.includes('pixverse')) {
    return '/logos/pixverse.png';
  }

  if (searchString.includes('gemini')) {
    return '/logos/gemini.png';
  }
    if (searchString.includes('minimax')) {
    return '/logos/minimax.png';
  }
  if (searchString.includes('google')) {
    return '/logos/google.png';
  }
  if (searchString.includes('stable') || searchString.includes('sdxl') || searchString.includes('stability')) {
    return '/logos/stability.png';
  }
  if (searchString.includes('llama') || searchString.includes('meta')) {
    return '/logos/meta.png';
  }
  if (searchString.includes('mistral') || searchString.includes('mixtral')) {
    return '/logos/mistral.png';
  }
  if (searchString.includes('deepseek')) {
    return '/logos/deepseek.png';
  }
  if (searchString.includes('grok') || searchString.includes('xai')) {
    return '/logos/grok.png';
  }
  if (searchString.includes('runway') || searchString.includes('gen3') || searchString.includes('gen-3')) {
    return '/logos/runway.png';
  }
  if (searchString.includes('pika')) {
    return '/logos/pika.png';
  }
  if (searchString.includes('flux') || searchString.includes('replicate')) {
    return '/logos/flux.png';
  }
  if (searchString.includes('ideogram')) {
    return '/logos/ideogram.png';
  }
  if (searchString.includes('luma') || searchString.includes('dream')) {
    return '/logos/luma.png';
  }
  if (searchString.includes('kling')) {
    return '/logos/kling.png';
  }
  if (searchString.includes('qwen') || searchString.includes('alibaba')) {
    return '/logos/qwen.png';
  }
  if (searchString.includes('cohere')) {
    return '/logos/cohere.png';
  }
  if (searchString.includes('yi-') || searchString.includes('01.ai')) {
    return '/logos/01ai.png';
  }

  return null;
};

// ==========================================
// ModelLogo Component
// ==========================================

function ModelLogo({ model, modelName, size = 'md', className = '', showNew = true }) {
  const [imageError, setImageError] = useState(false);

  const effectiveModel = model || (modelName ? { name: modelName, id: modelName } : null);

  if (!effectiveModel && !modelName) {
    return null;
  }

  const sizeClasses = {
    xs: 'w-5 h-5',
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-10 h-10',
    xl: 'w-12 h-12'
  };

  const sizeClass = sizeClasses[size] || sizeClasses.md;
  const displayName = effectiveModel?.name || effectiveModel?.id || modelName || 'AI';
  const initials = getInitials(displayName);
  const logoUrl = getLogoUrl(effectiveModel, modelName);

  if (!logoUrl || imageError) {
    return (
      <div className={`${sizeClass} ${getColorFromName(displayName)} rounded-lg flex items-center justify-center flex-shrink-0 shadow-sm ${className}`}>
        <span className="text-white font-bold text-xs">
          {initials}
        </span>
      </div>
    );
  }

  return (
    <img
      src={logoUrl}
      alt={displayName}
      className={`${sizeClass} rounded-lg object-contain flex-shrink-0 bg-white p-1 shadow-sm ${className}`}
      onError={() => {
        console.warn(`Failed to load logo: ${logoUrl}`);
        setImageError(true);
      }}
    />
  );
}

// ==========================================
// MiniModelLogo - For Stats Overlay
// ==========================================

function MiniModelLogo({ model, modelName, size = 16 }) {
  const [imageError, setImageError] = useState(false);
  const effectiveModel = model || (modelName ? { name: modelName, id: modelName } : null);
  const displayName = effectiveModel?.name || effectiveModel?.id || modelName || 'AI';
  const logoUrl = getLogoUrl(effectiveModel, modelName);

  if (!logoUrl || imageError) {
    const initials = getInitials(displayName);
    return (
      <div
        className={`${getColorFromName(displayName)} rounded flex items-center justify-center flex-shrink-0`}
        style={{ width: size, height: size }}
      >
        <span className="text-white font-bold" style={{ fontSize: size * 0.5 }}>
          {initials.charAt(0)}
        </span>
      </div>
    );
  }

  return (
    <img
      src={logoUrl}
      alt={displayName}
      className="rounded object-contain flex-shrink-0 bg-white"
      style={{ width: size, height: size }}
      onError={() => setImageError(true)}
    />
  );
}

// ==========================================
// Exports
// ==========================================

export default ModelLogo;
export { Icons, IconColors, getCategoryIcon, getComparisonColors };